import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  fromUTCtoZoneFormatted,
  storeGet,
} from 'mailup-react-helpers'

import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import getIntl from 'Helpers/intl'

import {
  beAutomationApiCanCreateAutomation,
  beAutomationApiGetAutomationWorkflow,
  beAutomationApiSearchWorkflows,
  beAutomationApiSetEnableWorkflow,
} from 'Api/beAutomationApiTS'

import type {
  ListItem,
  PaginationState,
} from 'Pages/UnsubscriptionCampaignsList/types'

import type {
  SearchWorkflowsInputData,
  WorkflowItem,
} from 'Types/beAutomationApi'

export const toResult =
  (TZ: string) =>
  ({
    Id,
    Name,
    Notes,
    Type,
    Draft,
    LastModifiedDate,
    LastActivationDate,
    Enabled,
    CountEmailMessages,
    RecipientLimit,
  }: WorkflowItem): ListItem => {
    return {
      Id,
      Name,
      Notes,
      Type,
      Draft,
      Enabled,
      CountEmailMessages,
      LastModifiedDate: fromUTCtoZoneFormatted(LastModifiedDate, TZ),
      LastActivationDate:
        LastActivationDate !== undefined && LastActivationDate !== null
          ? fromUTCtoZoneFormatted(LastActivationDate, TZ)
          : undefined,
      RecipientLimit,
    }
  }

export const fetchResults = async ({
  pageNumber,
  pageSize,
  orderBy,
  orderDescending,
}: {
  pageNumber: number
  pageSize: number
  orderBy: string
  orderDescending: boolean
}): Promise<[ListItem[], Partial<PaginationState>]> => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const dataIn: SearchWorkflowsInputData = {
    Status: 'All',
    Type: 'UnsubscriptionCampaign',
  }

  const { Items, TotalItems } = await beAutomationApiSearchWorkflows(
    idList,
    { pageNumber, pageSize, orderBy, orderDescending },
    dataIn,
  )

  if (Items.length === 0 && TotalItems > 0) {
    const newPageNumber = Math.ceil(TotalItems / pageSize)
    //  wrong page
    const results2 = await beAutomationApiSearchWorkflows(
      idList,
      {
        pageNumber: newPageNumber,
        pageSize,
        orderBy,
        orderDescending,
      },
      dataIn,
    )

    return [
      results2.Items.map(toResult(TimeZoneCode)),
      {
        pageNumber: newPageNumber,
        totalItems: results2.TotalItems,
      },
    ]
  }

  return [Items.map(toResult(TimeZoneCode)), { totalItems: TotalItems }]
}

export const fetchCanCreate = async (): Promise<boolean> => {
  const { Result } = await beAutomationApiCanCreateAutomation()

  return Result
}

export const setWorkflowStatus = async (
  idWorkflow: number,
  status: boolean,
): Promise<void> => {
  await beAutomationApiSetEnableWorkflow(idWorkflow, status)
}

export const notifyToggleStatus = (status: boolean): void => {
  toastShow(
    getIntl().formatMessage({
      id: status
        ? 'Load.AutomationWorkflow.SuccessEnable'
        : 'Load.AutomationWorkflow.SuccessDisable',
    }),
    TOAST_VARIANT_SUCCESS,
    `toggleStatus_${status.toString()}`,
  )
}

export const fetchWorkflow = async (idWorkflow: number): Promise<ListItem> => {
  const result = await beAutomationApiGetAutomationWorkflow(idWorkflow)

  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  return toResult(TimeZoneCode)(result)
}
